import { __read, __spread } from "tslib";
import { useRef } from 'react';
import { useEventCallback } from '../../../../foundation';
import { ACCEPTABLE_KEYS } from './DialPadUtils';
/**
 * Provide you can get event apply on trigger events area
 * @param options onKeyDown, onKeyUp that you also want apply on target
 * @returns  onKeyDown, onKeyUp, control
 */
export var useDialKeyboard = function (_a) {
    var _b = _a === void 0 ? {} : _a, onKeyDownArg = _b.onKeyDown, onKeyUpArg = _b.onKeyUp;
    var control = useRef(null);
    // we need `onKeyup` & `onKeydown` to get called in same amount, but also make sure of the performance.
    var keyBufferRef = useRef([]);
    var onKeyDown = useEventCallback(function (e) {
        var _a;
        onKeyDownArg === null || onKeyDownArg === void 0 ? void 0 : onKeyDownArg(e);
        var key = e.key;
        if (!ACCEPTABLE_KEYS.includes(key))
            return;
        e.preventDefault();
        e.stopPropagation();
        var buffer = keyBufferRef.current;
        if (!buffer.includes(key)) {
            keyBufferRef.current = __spread(buffer, [key]);
            (_a = control.current) === null || _a === void 0 ? void 0 : _a.handleKeyboardEffect(key, false);
        }
    });
    var onKeyUp = useEventCallback(function (e) {
        var _a;
        onKeyUpArg === null || onKeyUpArg === void 0 ? void 0 : onKeyUpArg(e);
        var key = e.key;
        if (!ACCEPTABLE_KEYS.includes(key))
            return;
        e.preventDefault();
        e.stopPropagation();
        keyBufferRef.current = keyBufferRef.current.filter(function (bufferedKey) { return bufferedKey !== key; });
        (_a = control.current) === null || _a === void 0 ? void 0 : _a.handleKeyboardEffect(key, true);
    });
    return { onKeyDown: onKeyDown, onKeyUp: onKeyUp, control: control };
};
